import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface AdminAuthState {
  isLoggedIn: boolean;
  admin: Admin | null;
  accessToken: string | null;
  refreshToken: string | null;

  login: (admin: Admin, accessToken: string, refreshToken: string) => void;
  logout: () => void;
}

const useAdminAuth = create<AdminAuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      admin: null,
      accessToken: null,
      refreshToken: null,

      login: (admin, accessToken, refreshToken) =>
        set({
          isLoggedIn: true,
          admin,
          accessToken,
          refreshToken
        }),
      logout: () =>
        set({
          isLoggedIn: false,
          admin: null,
          accessToken: null,
          refreshToken: null
        })
    }),
    {
      name: 'auth-admin-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useAdminAuth;
